(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/api-caller/assets/javascripts/api-map.js') >= 0) return;  svs.modules.push('/components/tur/api-caller/assets/javascripts/api-map.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const METHOD_GET = 'GET';
const METHOD_DELETE = 'DELETE';
const METHOD_POST = 'POST';
const METHOD_PUT = 'PUT';

const charityPaths = {
  getCharityExternalcharities: {
    jupiterPath: _ref => {
      let {
        jupiterVersion = 1
      } = _ref;
      return "/charity/".concat(jupiterVersion, "/externalcharities");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCharityExternalcharitiesById: {
    jupiterPath: _ref2 => {
      let {
        charityId,
        jupiterVersion = 1
      } = _ref2;
      return "/charity/".concat(jupiterVersion, "/externalcharities/").concat(charityId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCharityPayoutstatistics: {
    jupiterPath: _ref3 => {
      let {
        drawIds,
        jupiterVersion = 1
      } = _ref3;
      const basePath = "/charity/".concat(jupiterVersion, "/payoutstatistics");
      if (drawIds && Array.isArray(drawIds) && drawIds.length > 0) {
        const queryString = drawIds.map(id => "drawIds=".concat(id)).join('&');
        return "".concat(basePath, "?").concat(queryString);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const drawPaths = {
  getDrawProductDraws: {
    jupiterPath: _ref4 => {
      let {
        product,
        jupiterVersion = 1
      } = _ref4;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawProductDrawsByDrawNumber: {
    jupiterPath: _ref5 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref5;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/").concat(drawNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawProductDrawsResult: {
    jupiterPath: _ref6 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref6;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/").concat(drawNumber, "/result");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawProductDrawsResultByspan: {
    jupiterPath: _ref7 => {
      let {
        product,
        days,
        jupiterVersion = 1
      } = _ref7;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/result/byspan?days=").concat(days);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawProductDrawsResultLatest: {
    jupiterPath: _ref8 => {
      let {
        product,
        jupiterVersion = 1
      } = _ref8;
      return "/draw/".concat(jupiterVersion, "/").concat(product, "/draws/result");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawResultsDatepicker: {
    jupiterPath: _ref9 => {
      let {
        product,
        year,
        month,
        jupiterVersion = 1
      } = _ref9;
      return "/draw/".concat(jupiterVersion, "/results/datepicker?product=").concat(product, "&year=").concat(year, "&month=").concat(month);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawJackpot: {
    jupiterPath: _ref0 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref0;
      return "/draw/".concat(jupiterVersion, "/jackpot/draws?product=").concat(product, "&drawNumber=").concat(drawNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawActiveCampaigns: {
    jupiterPath: _ref1 => {
      let {
        jupiterVersion = 1
      } = _ref1;
      return "/draw/".concat(jupiterVersion, "/campaigns");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawActiveCampaignsByProduct: {
    jupiterPath: _ref10 => {
      let {
        product,
        jupiterVersion = 1
      } = _ref10;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawCampaignByCampaignDraw: {
    jupiterPath: _ref11 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref11;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product, "/").concat(drawNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawCampaignDatePicker: {
    jupiterPath: _ref12 => {
      let {
        product,
        year,
        month,
        jupiterVersion = 1
      } = _ref12;
      return "/draw/".concat(jupiterVersion, "/campaign/datepicker?year=").concat(year, "&month=").concat(month, "&product=").concat(product);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getDrawCampaignResultByDraw: {
    jupiterPath: _ref13 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref13;
      return "/draw/".concat(jupiterVersion, "/campaign/").concat(product, "/").concat(drawNumber, "/result");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const playerPaths = {
  getPlayerActiveWagers: {
    jupiterPath: _ref14 => {
      let {
        productId,
        count,
        pagingSortKey,
        jupiterVersion = 1
      } = _ref14;
      let basePath = "/player/".concat(jupiterVersion, "/wagers?status=Active");
      if (productId) {
        basePath += "&productId=".concat(productId);
      }
      if (count) {
        basePath += "&count=".concat(count);
      }
      if (pagingSortKey) {
        basePath += "&pagingSortKey=".concat(pagingSortKey);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerFinishedWagers: {
    jupiterPath: _ref15 => {
      let {
        productId,
        count,
        pagingSortKey,
        jupiterVersion = 1
      } = _ref15;
      let basePath = "/player/".concat(jupiterVersion, "/wagers?status=Finished");
      if (productId) {
        basePath += "&productId=".concat(productId);
      }
      if (count) {
        basePath += "&count=".concat(count);
      }
      if (pagingSortKey) {
        basePath += "&pagingSortKey=".concat(pagingSortKey);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerActivesubscriptions: {
    jupiterPath: _ref16 => {
      let {
        jupiterVersion = 1
      } = _ref16;
      return "/player/".concat(jupiterVersion, "/activesubscriptions");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerAddress: {
    jupiterPath: _ref17 => {
      let {
        customerId,
        jupiterVersion = 2
      } = _ref17;
      return "/player/".concat(jupiterVersion, "/address?customerId=").concat(customerId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerAdressFinder: {
    jupiterPath: _ref18 => {
      let {
        jupiterVersion = 1
      } = _ref18;
      return "/player/".concat(jupiterVersion, "/addressfinder");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerPreferences: {
    jupiterPath: _ref19 => {
      let {
        jupiterVersion = 1
      } = _ref19;
      return "/player/".concat(jupiterVersion, "/preferences");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerPreferencesAddressGeoLocation: {
    jupiterPath: _ref20 => {
      let {
        jupiterVersion = 1
      } = _ref20;
      return "/player/".concat(jupiterVersion, "/preferences/30/key?preferenceKey=addressGeoLocation");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerProperties: {
    jupiterPath: _ref21 => {
      let {
        jupiterVersion = 1
      } = _ref21;
      return "/player/".concat(jupiterVersion, "/properties");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSubscription: {
    jupiterPath: _ref22 => {
      let {
        subscriptionId,
        jupiterVersion = 1
      } = _ref22;
      return "/player/".concat(jupiterVersion, "/subscription?subscription=").concat(subscriptionId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerWagerById: {
    jupiterPath: _ref23 => {
      let {
        wagerId,
        jupiterVersion = 1
      } = _ref23;
      return "/player/".concat(jupiterVersion, "/wagers/").concat(wagerId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerWagerByStatus: {
    jupiterPath: _ref24 => {
      let {
        branding,
        jupiterVersion = 1
      } = _ref24;
      return "/player/".concat(jupiterVersion, "/wagers?status=Active&productId=").concat(branding);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSuspensions: {
    jupiterPath: _ref25 => {
      let {
        jupiterVersion = 1
      } = _ref25;
      return "/player/".concat(jupiterVersion, "/suspensions");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerDepositlimits: {
    jupiterPath: _ref26 => {
      let {
        jupiterVersion = 2
      } = _ref26;
      return "/player/".concat(jupiterVersion, "/depositlimits");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerObjectstore: {
    jupiterPath: _ref27 => {
      let {
        keys,
        jupiterVersion = 1
      } = _ref27;
      return "/player/".concat(jupiterVersion, "/objectstore?keys=").concat(keys);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postPlayerObjectstore: {
    jupiterPath: _ref28 => {
      let {
        jupiterVersion = 1
      } = _ref28;
      return "/player/".concat(jupiterVersion, "/objectstore");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getPlayerSettings: {
    jupiterPath: _ref29 => {
      let {
        jupiterVersion = 1
      } = _ref29;
      return "/player/".concat(jupiterVersion, "/settings");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  putPlayerSettings: {
    jupiterPath: _ref30 => {
      let {
        jupiterVersion = 1
      } = _ref30;
      return "/player/".concat(jupiterVersion, "/settings");
    },
    elzaPath: () => null,
    method: METHOD_PUT
  },
  getPlayerReserved: {
    jupiterPath: _ref31 => {
      let {
        product,
        jupiterVersion = 1
      } = _ref31;
      let basePath = "/player/".concat(jupiterVersion, "/marketplace/svs/activateddraws/reserved");
      if (product) {
        basePath += "?product=".concat(product);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerSponsorshipReceiverSelection: {
    jupiterPath: _ref32 => {
      let {
        active = true,
        jupiterVersion = 1
      } = _ref32;
      return "/player/".concat(jupiterVersion, "/sponsorship/receiverselection?active=").concat(active);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerValidatedTicket: {
    jupiterPath: _ref33 => {
      let {
        ticketNumber,
        jupiterVersion = 1
      } = _ref33;
      return "/player/".concat(jupiterVersion, "/validatedticket?ticketnumber=").concat(ticketNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getPlayerInfo: {
    jupiterPath: _ref34 => {
      let {
        jupiterVersion = 3
      } = _ref34;
      return "/player/".concat(jupiterVersion, "/info?include=accountBalance,currentStatus");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const marketplacePaths = {
  getMarketplaceContainers: {
    jupiterPath: _ref35 => {
      let {
        product,
        jupiterVersion = 1
      } = _ref35;
      let basePath = "/marketplace/".concat(jupiterVersion, "/svs/containers");
      if (product) {
        basePath += "?product=".concat(product);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getMarketplaceActivatedDrawsById: {
    jupiterPath: _ref36 => {
      let {
        activatedDrawId,
        jupiterVersion = 1
      } = _ref36;
      return "/marketplace/".concat(jupiterVersion, "/svs/activateddraws/").concat(activatedDrawId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const subscriptionPaths = {
  postSubscriptionDisable: {
    jupiterPath: _ref37 => {
      let {
        jupiterVersion = 2
      } = _ref37;
      return "/subscription/".concat(jupiterVersion, "/disablesubscription");
    },
    elzaPath: () => null,
    method: METHOD_PUT
  },
  postSubscriptionSelectCharity: {
    jupiterPath: _ref38 => {
      let {
        jupiterVersion = 2
      } = _ref38;
      return "/subscription/".concat(jupiterVersion, "/selectcharity");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const wagerPaths = {
  deleteWager: {
    jupiterPath: _ref39 => {
      let {
        wagerId,
        jupiterVersion = 5
      } = _ref39;
      return "/wager/".concat(jupiterVersion, "/wagers/").concat(wagerId);
    },
    elzaPath: () => null,
    method: METHOD_DELETE
  },
  postWagerWagers: {
    jupiterPath: _ref40 => {
      let {
        jupiterVersion = 10
      } = _ref40;
      return "/wager/".concat(jupiterVersion, "/wagers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postWagerMultiwagers: {
    jupiterPath: _ref41 => {
      let {
        jupiterVersion = 10
      } = _ref41;
      return "/wager/".concat(jupiterVersion, "/multiwagers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const socialPaths = {
  getSocialSyndicates: {
    jupiterPath: _ref42 => {
      let {
        jupiterVersion = 2
      } = _ref42;
      return "/social/".concat(jupiterVersion, "/syndicates");
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getSocialSyndicatesById: {
    jupiterPath: _ref43 => {
      let {
        syndicateId,
        jupiterVersion = 1
      } = _ref43;
      return "/social/".concat(jupiterVersion, "/syndicates/").concat(syndicateId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getSocialSyndicateNamesById: {
    jupiterPath: _ref44 => {
      let {
        syndicateId,
        jupiterVersion = 1
      } = _ref44;
      return "/social/".concat(jupiterVersion, "/syndicatenames/").concat(syndicateId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};


const extraChanserPaths = {
  getCustomerResultsInfo: {
    jupiterPath: _ref45 => {
      let {
        productId = 0,
        drawnum = 0,
        getAllDraws = true,
        jupiterVersion = 1
      } = _ref45;
      return "/extrachanser/".concat(jupiterVersion, "/customerresultsinfo?productId=").concat(productId, "&drawnum=").concat(drawnum, "&getAllDraws=").concat(getAllDraws);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCustomerResultsInfoExt: {
    jupiterPath: _ref46 => {
      let {
        accessToken,
        jupiterVersion = 1
      } = _ref46;
      return "/extrachanser/".concat(jupiterVersion, "/customerresultsinfoext?uuid=").concat(accessToken);
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};


const contentPaths = {
  getContentVideoYoutubePlaylist: {
    jupiterPath: _ref47 => {
      let {
        playlistId,
        date,
        routesDomain = 'tur',
        jupiterVersion = 1
      } = _ref47;
      return "/content/".concat(jupiterVersion, "/video/youtube/playlist?playlistId=").concat(playlistId, "&date=").concat(date, "&routesDomain=").concat(routesDomain);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getContentWithIds: {
    jupiterPath: _ref48 => {
      let {
        ids,
        routesDomain = 'tur',
        jupiterVersion = 2
      } = _ref48;
      let basePath = "/content/".concat(jupiterVersion, "/id");
      if (ids) {
        const idsArray = Array.isArray(ids) ? ids : [ids];
        basePath += "?ids=".concat(idsArray.join(','));
      }
      if (routesDomain) {
        basePath += "&routesDomain=".concat(routesDomain);
      }
      return basePath;
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const ticketPaths = {
  postPlayerValidateTicket: {
    jupiterPath: _ref49 => {
      let {
        jupiterVersion = 1
      } = _ref49;
      return "/ticket/".concat(jupiterVersion, "/playervalidateticket");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postPersonalVouchers: {
    jupiterPath: _ref50 => {
      let {
        jupiterVersion = 1
      } = _ref50;
      return "/ticket/".concat(jupiterVersion, "/personalvouchers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postMailboxPlayerOrder: {
    jupiterPath: _ref51 => {
      let {
        jupiterVersion = 1
      } = _ref51;
      return "/ticket/".concat(jupiterVersion, "/mailbox/playerorder");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  postMailboxGiftOrder: {
    jupiterPath: _ref52 => {
      let {
        jupiterVersion = 1
      } = _ref52;
      return "/ticket/".concat(jupiterVersion, "/mailbox/giftorder");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getMailBoxOrderReferenceId: {
    jupiterPath: _ref53 => {
      let {
        referenceId,
        jupiterVersion = 1
      } = _ref53;
      return "/ticket/".concat(jupiterVersion, "/mailbox/orders/").concat(referenceId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postGiftVouchers: {
    jupiterPath: _ref54 => {
      let {
        jupiterVersion = 1
      } = _ref54;
      return "/ticket/".concat(jupiterVersion, "/giftvouchers");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
};

const voucherPaths = {
  postVoucherSendBySms: {
    jupiterPath: _ref55 => {
      let {
        jupiterVersion = 1
      } = _ref55;
      return "/voucher/".concat(jupiterVersion, "/sendbysms");
    },
    elzaPath: () => null,
    method: METHOD_POST
  },
  getVoucherById: {
    jupiterPath: _ref56 => {
      let {
        voucherId,
        jupiterVersion = 6
      } = _ref56;
      return "/voucher/".concat(jupiterVersion, "/getvoucher/?voucherId=").concat(voucherId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getVoucherMetadata: {
    jupiterPath: _ref57 => {
      let {
        voucherId,
        jupiterVersion = 1
      } = _ref57;
      return "/voucher/".concat(jupiterVersion, "/vouchermetadata?voucherId=").concat(voucherId);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getVouchersConfig: {
    jupiterPath: _ref58 => {
      let {
        jupiterVersion = 1
      } = _ref58;
      return "/voucher/".concat(jupiterVersion, "/vouchersconfig");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};

const AuthorizationPaths = {
  getAuthorizationOath2: {
    jupiterPath: _ref59 => {
      let {
        jupiterVersion = 1
      } = _ref59;
      return "/authorization/".concat(jupiterVersion, "/oauth2/auth");
    },
    elzaPath: () => null,
    method: METHOD_GET
  }
};
const apiMap = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, charityPaths), drawPaths), playerPaths), marketplacePaths), wagerPaths), socialPaths), subscriptionPaths), extraChanserPaths), contentPaths), ticketPaths), voucherPaths), AuthorizationPaths), {}, {
  getCacheTokens: {
    jupiterPath: _ref60 => {
      let {
        accessToken,
        jupiterVersion = 2
      } = _ref60;
      return "/cache/".concat(jupiterVersion, "/tokens/").concat(accessToken);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  getCustomerbetWagerByDraw: {
    jupiterPath: _ref61 => {
      let {
        product,
        drawNumber,
        jupiterVersion = 1
      } = _ref61;
      return "/customerbet/".concat(jupiterVersion, "/wager/by/draw?product=").concat(product, "&drawNumber=").concat(drawNumber);
    },
    elzaPath: () => null,
    method: METHOD_GET
  },
  postGeoSelectCharity: {
    jupiterPath: _ref62 => {
      let {
        jupiterVersion = 2
      } = _ref62;
      return "/geo/".concat(jupiterVersion, "/selectcharity");
    },
    elzaPath: () => null,
    method: METHOD_POST
  }
});
if (svs.isServer) {
  module.exports = {
    apiMap
  };
} else {
  setGlobal('svs.tur.apiCaller.apiMap', apiMap);
}

 })(window);